module.exports = __webpack_public_path__ + "static/media/blockchain.cef82c5c.PNG";